import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { channels } from "@/mocks/home";

export default function Channels() {
  return (
    <section
      id="channels"
      className="border-y border-background-200/70 bg-background-100 py-16 md:py-28"
    >
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
        <Reveal>
          <SectionHeading
            kicker="Submission Channels"
            title="三种黑料投稿联系方式"
            description="从短线索到完整材料，都可以找到合适的匿名投稿渠道。三种方式彼此独立，您只需挑选最顺手的一种，无需全部填写。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-3 md:mt-16 md:gap-5 md:grid-cols-3">
          {channels.map((channel, index) => (
            <Reveal key={channel.id} delay={index * 90} className="h-full">
              <article className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-50 p-6 md:p-8">
                <div className="flex items-start justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${channel.icon} text-xl`} />
                  </span>
                  <span className="font-heading text-2xl text-background-400">{channel.index}</span>
                </div>

                <h3 className="mt-6 font-heading text-xl text-foreground-950">{channel.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {channel.summary}
                </p>

                <ul className="mt-6 space-y-2.5 border-t border-background-200/70 pt-5">
                  {channel.points.map((point) => (
                    <li key={point} className="flex items-start gap-2.5 font-label text-sm text-foreground-700">
                      <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" />
                      {point}
                    </li>
                  ))}
                </ul>

                <a
                  href="#faq"
                  className="mt-7 inline-flex items-center gap-2 font-label text-sm text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
                >
                  查看常见问题
                  <i className="ri-arrow-right-line" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}